import axios from 'axios'
import type { AxiosInstance, AxiosResponse } from 'axios'
import type { 
    BindLinkRequest, 
    BindLinkResponse, 
    GetLinkStatusRequest, 
    GetLinkStatusResponse 
} from '@/types/api'

import i18n from '../i18n'

class ApiService {
    private api: AxiosInstance

    constructor() {
        // In development, use relative URL to enable proxy
        // In production, use the full VITE_BASE_URL
        const baseURL = import.meta.env.DEV ? '' : import.meta.env.VITE_BASE_URL
        
        this.api = axios.create({
            baseURL,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': i18n.global.locale.value,
            }
        })

        // Request interceptor
        this.api.interceptors.request.use(
            (config) => {
                return config
            },
            (error) => {
                return Promise.reject(error)
            }
        )

        // Response interceptor
        this.api.interceptors.response.use(
            (response: AxiosResponse) => response,
            (error) => {
                console.error('API Error:', error)

                // Check for 403 with request_in_progress code
                if (error.response?.status === 403 && error.response?.data?.code === 'request_in_progress') {
                    // Add a flag to identify this specific error type
                    error.isRequestInProgress = true
                }

                return Promise.reject(error)
            }
        )
    }

    /**
     * Submit email for bind request
     */
    async bindRequest(data: BindLinkRequest): Promise<BindLinkResponse> {
        try {
            const response = await this.api.post<BindLinkResponse>('/api/mobile/v1/residency/bind-request', data)
            return response.data
        } catch (error) {
            console.error('Bind request failed:', error)
            throw error
        }
    }

    /**
     * Get link status
     */
    async getLinkStatus(params: GetLinkStatusRequest): Promise<GetLinkStatusResponse> {
        try {
            const response = await this.api.get<GetLinkStatusResponse>('/api/mobile/v1/residency/bind-request/status', {
                params
            })
            return response.data
        } catch (error) {
            console.error('Get link status failed:', error)
            throw error
        }
    }
}

export const apiService = new ApiService()
export default apiService